import { DropdownMenu } from '@paypalcorp/pp-react'
import { trackClick, trackFormValidationClick } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { isEmpty } from 'lodash-es'

import React, { useEffect, useState, useRef } from 'react'

const DropdownFieldAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const { options: dropdownOptions, label } = rest

  const [searchBuffer, setSearchBuffer] = useState('')
  const searchTimeoutRef = useRef(null)

  let dropdownButtonId = ''
  if (label) {
    dropdownButtonId = label.replace(/\s+/g, '')
  }

  const dropDownElementButton = document.getElementById(
    `dropdownMenuButton_${dropdownButtonId}`,
  )

  const handleKeyDown = (event) => {
    if (isEmpty(dropdownOptions)) {
      return
    }
    const key = event.key.toLowerCase()
    // Only handle alphabet keys
    if (/^[a-z]$/.test(key)) {
      if (dropDownElementButton) {
        dropDownElementButton.click()
      }
      setSearchBuffer((prevBuffer) => prevBuffer + key)
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
      searchTimeoutRef.current = setTimeout(() => setSearchBuffer(''), 1000)
      const match = dropdownOptions.find((option) =>
        option?.primaryText.toLowerCase().startsWith(searchBuffer + key),
      )
      if (match) {
        input.onChange(match.value)
      }
    }
  }

  const handleChange = (event) => {
    input.onChange(event.target?.value)
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
      event_name: FPTI_EVENTS.FORM.FIELD_PRESSED,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackFormValidationClick({
        page: fptiPage,
        message: meta.error,
        component: input.name,
        link: input.name,
        event_name: FPTI_EVENTS.FORM.VALIDATION_ERROR,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <DropdownMenu
      {...input}
      {...rest}
      onChange={handleChange}
      errorText={meta.touched ? meta.error : ''}
      onKeyDown={handleKeyDown}
    />
  )
}

export default DropdownFieldAdapter
